/* global gdAlertify */
import React, { useState } from 'react';
import Logo from '../assets/images/sk-logo.png';
import axiosInstance from '../config/axiosConfig';
import { useNavigate } from 'react-router-dom';

function CambiarContrasena() {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleCambiarContrasena = (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            gdAlertify.notiError('Las contraseñas no coinciden');
            return;
        }

        setIsLoading(true);
        axiosInstance.post('/usuario/cambiar-contrasena', { password })
            .then((response) => {
                setIsLoading(false);
                const result = response.data;
                
                if (result.error) {
                    gdAlertify.notiError(result.message);
                    return;
                }
                
                gdAlertify.notiSuccess('Contraseña cambiada con éxito');
                navigate("/");
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
                gdAlertify.notiError('Hubo un error en la solicitud');
            });
    };

    return (
        <div className='container d-flex justify-content-center align-items-center'>
            <div className="card mt-5">
                <div className="card-body">
                    <div className="login-container text-center">
                        <h2>Cambiar Contraseña</h2>
                        <form onSubmit={handleCambiarContrasena}>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Nueva Contraseña</label>
                                <input
                                    type="password"
                                    id="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="confirmPassword" className="form-label">Confirmar Contraseña</label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                {isLoading ? 'Cambiando...' : 'Cambiar Contraseña'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CambiarContrasena;
